import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogResponse } from 'src/app/shared/models/constants/mat-dialog-response';

export interface SecondaryContent {
  content: string;
  style: { [key: string]: string };
}

export interface DialogModalData {
  title?: string;
  content?: string;
  secondaryContent?: SecondaryContent[];
  successButtonText?: string;
  successButtonIcon?: string;
  failButtonText?: string;
  options?: string[];
  optionsLabel?: string;
  optionsPlaceholder?: string;
  contentKeepWhiteSpace?: boolean;
  hasDisclaimer?: boolean;
  isRedButton?: boolean;
  isNewDesign?: boolean;
  disclaimer?: string;
  contactSsupportDisclaimer?: string;
  faqLink?: string;
}

@Component({
  selector: 'app-modal',
  templateUrl: './dialog-modal.component.html',
  styleUrls: ['./dialog-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
/**
 * Modal molecule
 */
export class DialogModalComponent implements OnInit {
  selectControl = new FormControl('', Validators.required);

  /**
   * @constructor
   */
  constructor(
    private dialogRef: MatDialogRef<DialogModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogModalData
  ) {}

  /**
   * on init
   */
  ngOnInit() {
    if (this.data.isRedButton) {
      this.data.isNewDesign = true;
    }
    if (this.hasOptions && this.data.options!.length === 1) {
      this.selectControl.setValue(this.data.options![0]);
    }
  }

  /**
   * Action to close the dialog
   */
  onSuccessClick() {
    let response: MatDialogResponse | string;
    if (this.hasOptions) {
      response = this.selectControl?.value!;
    } else {
      response = MatDialogResponse.SUCCESS;
    }
    this.dialogRef.close(response);
  }

  /**
   * Action to close the dialog
   */
  onFailClick() {
    this.dialogRef.close(MatDialogResponse.FAIL);
  }

  /**
   * gets options from data
   */
  get hasOptions() {
    return this.data.options && this.data.options.length > 0;
  }

  /**
   * Gets control if options are available
   */
  get controlOrNothing() {
    if (this.hasOptions) {
      return this.selectControl;
    } else {
      return undefined;
    }
  }

  /**
   * Label to show for select
   */
  get optionsLabel() {
    return this.data.optionsLabel || '';
  }

  /**
   * If whitespace should be kept (pre) in dialog content
   */
  get contentKeepWhiteSpace() {
    return Boolean(this.data.contentKeepWhiteSpace);
  }
}
